// @flow
import * as React from 'react';
import Box from 'sail/Box';
import {Heading} from 'docs/components';
import {ButtonLink} from 'sail/Button';

type ElementsHeroProps = {|
  children: React.Node,
  title: string,
  linkHref: string,
  linkLabel: string,
  imageSrc: string,
|};

export const ElementsHero = ({
  children,
  title,
  linkHref,
  linkLabel,
  imageSrc,
}: ElementsHeroProps) => {
  return (
    <Box
      className="HeroSection"
      flex={{direction: 'row', alignItems: 'center'}}
      margin={{bottom: 16}}
      style={{minHeight: '240px'}}
    >
      <Box padding={{right: 20}} flexGrow={1}>
        <Heading level={3}>{title}</Heading>
        <Box className="HeroSection-text" padding={{bottom: 20, right: 32}}>
          {children}
        </Box>
        <ButtonLink
          icon={'arrowRight'}
          iconPosition="right"
          color="blue"
          label={linkLabel}
          size="large"
          href={linkHref}
          display="inline-flex"
        />
      </Box>
      <Box
        flexGrow={1}
        flex={{justifyContent: 'flex-end'}}
        className="HeroSection-right"
      >
        <img className="HeroSection-right-image" alt="" src={imageSrc} />
      </Box>
    </Box>
  );
};
